import Dashboard from './Dashboard'
import Home from './Home'

export default {
  Dashboard,
  Home,
}
